export const updateCurrentComponentAction = (state) => {
  return {
    type: "UPDATE_CURRENT_COMPONENT",
    payload: state,
  };
};
